export enum DiagnosticType {
    Aspiration = 'ASPIRATION',
    SelfMastery = 'SELF_MASTERY',
    Competence = 'COMPETENCE',
    Environment = 'ENVIRONMENT',
    Opportunity = 'OPPORTUNITY',
    Delivery = 'DELIVERY',
    Wellness = 'WELLNESS'
}
